import type { ArColumnAggregation } from '#types/System.Artifacts.types';

const ArColumnAggregationOptions: Array<{ value: ArColumnAggregation; label: string }> = [
  { value: 'sum', label: 'Sum' },
  { value: 'avg', label: 'Average' },
  { value: 'min', label: 'Min' },
  { value: 'max', label: 'Max' },
  { value: 'count', label: 'Count' },
];

export default ArColumnAggregationOptions;
